<template>
  <div class="alert-container">
    <transition name="popup">
    <div class="popup-container" v-if="load.flag">
      <Loading :loadtext="load.text || '加载中'" loadtype="2" />
    </div>
    </transition>
    <transition name="popup">
    <div class="popup-container" v-if="msg.flag" @click="touchHide">
      <div class="msg-style">
        <p class="box-style alert-text" :class="{'warn': msg.status == 'warn'}">{{ msg.text }}</p>
      </div>
    </div>
    </transition>
  </div>
</template>

<script>
import Loading from '../../components/public/Loading'
export default {
  name: 'Alert',
  data () {
    return {
      timeId1: '',
      timeId2: '',
      load: {
        flag: false,
        text: ''
      },
      msg: {
        flag: false,
        text: '',
        status: ''
      }
    }
  },
  components: {
    Loading
  },
  methods: {
    showMsg (status = '', text = '') {
      if (text === '') return
      clearTimeout(this.timeId1)
      clearTimeout(this.timeId2)
      this.msg.status = status
      this.msg.text = text
      this.msg.flag = true
      this.timeId1 = setTimeout(this.hideMsg, 2000)
    },
    hideMsg () {
      clearTimeout(this.timeId1)
      clearTimeout(this.timeId2)
      this.msg.flag = false
      this.timeId2 = setTimeout(() => {
        this.msg.text = ''
        this.msg.status = ''
      }, 400)
    },
    touchHide () {
      this.hideMsg()
    },
    setLoad (flag = false, text = '') {
      this.load.text = text
      this.load.flag = flag
    }
  }
}
</script>

<style scoped>
.alert-container {
  position: fixed;
  width: 0;
  height: 0;
  z-index: 9999;
}
.popup-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}
.box-style {
  padding: .15rem;
  box-shadow: 0 .1rem .5rem rgba(0, 0, 0, .2);
  text-align: center;
  background-color: rgba(255, 255, 255, .8);
  font-size: .28rem;
  color: #333;
}
.msg-style {
  position: absolute;
  top: 1rem;
  left: 0;
  right: 0;
  text-align: center;
  transition: transform .4s cubic-bezier(0.32, 0.08, 0.24, 1);
}
.msg-style .box-style {
  display: inline-block;
  max-width: 80%;
  min-width: 40%;
  padding-right: .5rem;
  padding-left: .5rem;
  border-radius: 1rem;
}
.msg-style .box-style.warn {
  color: #ea4e3d;
  border-color: rgba(234, 78, 61, .8);
  box-shadow: 0 .1rem .5rem rgba(234, 78, 61, .3);
}
.popup-enter-active,
.popup-leave-active {
  transition: opacity .4s cubic-bezier(0.32, 0.08, 0.24, 1);
}
.popup-enter,
.popup-leave-to {
  opacity: 0;
}
.popup-enter .msg-style,
.popup-leave-to .msg-style {
  transform: translateY(-100%);
}
</style>
